<nb-select fullWidth [(selected)]="value" [disabled]="isDisabled">
  <nb-option *ngFor="let buildingCondition of Conditions" [value]="buildingCondition">
    {{ buildingCondition | conditionTranslation}}
  </nb-option>
</nb-select>
